import { useQuery } from "@tanstack/react-query";
import { CACHE_KEY_REQUESTFORQUOTATION } from "../../../../utils/constants";
import documentTemplateService from "../../../../services/general/documentTemplateService";

const useRFQSchema = () =>
  useQuery<string[], Error>({
    queryKey: [`${CACHE_KEY_REQUESTFORQUOTATION}Schema`],
    queryFn: () =>
      documentTemplateService.GetSchema("RequestForQuotationModule"),
    initialData: [],
  });

export default useRFQSchema;
